
//creamos las action types para utilizar en las action y en el reducer
export const GET_DOGS = 'GET_DOGS'
export const FILTER_CREATED = 'FILTER_CREATED'
export const FILTER_BY_TEMP = 'FILTER_BY_TEMP'
export const ORDER_BY_NAME = 'ORDER_BY_NAME'
export const ORDER_BY_WEIGHT = 'ORDER_BY_WEIGHT'
export const GET_NAME_DOGS = 'GET_NAME_DOGS'
export const GET_TEMPERAMENTS = 'GET_TEMPERAMENTS'
export const POST_DOG = 'POST_DOG'
export const GET_DETAIL = 'GET_DETAIL'
export const DELETE_DOG = 'DELETE_DOG'